<template>
    <div class="shift-container">
        <labelc type="header underline centered" :text="header" v-if="header"/>
        <div class="page-container" v-if="shifts.length > 0 && !(shifts.length === 1 && shifts[0].vmCount)">
            <labelc type="tab centered" v-bind:class="{selected: tab === tabSelected}" :text="tab + 1" v-for="(tab, index) in pages" :key="tab" @click="tabSelected = tab"/>
            <buttonc class="filter" type="square" :styleIcon="{'font-size': '13px'}" icon="fa-filter" @click="OpenFilterPopup"/>
            <buttonc class="filter toggle" type="square label-center" label="/" v-bind:class="{active: !filterToggle}" :styleIcon="{'font-size': '13px'}" :styleLabel="{
                'font-size': '20px',
                'color': 'var(--contrast-2)',
                'top': '-5px',
                'left': '2px'
            }"
             icon="fa-filter" @click="ToggleFilter"/>
            <buttonc class="sort" type="square" :styleIcon="{'font-size': '13px'}" icon="fa-angle-down" @click="showSort = !showSort"/>
        </div>
        <div class="page-container" v-if="showSort">
            <labelc type="tab centered" :text="sort" :icon-right="(sortState[sort] === 'ascending' ? {icon: 'fa-angle-down', type: 'small', styleButton: {'margin-right': '-10px'}} : sortState[sort] === 'descending' ? {icon: 'fa-angle-up', type: 'small', styleButton: {'margin-right': '-10px'}} : null)" v-for="(sort, index) in Object.keys(sortState)" :key="sort" @click="SortShifts(sort)"/>
        </div>
        <div class="scroll-list">
            <div class="shift" v-for="(shift, index) in shiftsFiltered" @click="ShiftSelect(shift)" :key="shift.id" @contextmenu.prevent.stop="openShiftContextMenu($event, shift)"
                 v-on:mousedown="DragStart($event, shift)" v-tooltip="spotMap[shift.spotId].name">
                <rosterday :state="{shifts: shift, spotMap: spotMap}"  v-bind:class="{selected: dayModeShiftsSelected && dayModeShiftsSelected.find(s => s === shift)}"/>
                <!--<timebar :eventProp="GetTimeBarShiftProp(dayModeDate, shift)" @timebar-update-shift="onTimebarUpdateShift"/>-->
            </div>
        </div>
        
    </div>
</template>

<script>
    export default {
        name: "shiftcontainer",
        data(){
            return {
                shifts: [],
                spotMap: {},
                shiftsPerPage: 16,
                tabSelected: 0,
                filterState: {
                    spotId: [],
                    from: this.$helpers.getMomentTZStartOfDay().dayOfYear(1),
                    to: this.$helpers.getMomentTZStartOfDay().add(1, 'year').dayOfYear(0),
                },
                filterStateInit: {
                    spotId: [],
                    from: this.$helpers.getMomentTZStartOfDay().dayOfYear(1),
                    to: this.$helpers.getMomentTZStartOfDay().add(1, 'year').dayOfYear(0),
                },
                showSort: false,
                filterToggle: true,
                shiftContextMenuOptions: [
                    {
                        name: this.$t('global.ui.edit'),
                        icon: 'fa-edit',
                        key: 'edit'
                    }
                ]
            }
        },
        watch: {
            state: {
                immediate: true,
                handler(newVal, oldVal) {
                    for (let x in newVal) this[x] = newVal[x];
                    if(newVal.shifts && newVal.shifts.slice) this.shifts = newVal.shifts.slice();
                    if(this.shifts && this.shifts.length === undefined) {
                        let temp = [];
                        temp.push(this.shifts);
                        this.shifts = temp;
                    }
                    if(newVal.spotMap){
                        this.filterStateInit.spotId = Object.values(newVal.spotMap).map(s => s.id);
                        if(this.date){
                            this.filterStateInit.from = this.date.clone().startOf('day');
                            this.filterStateInit.to = this.date.clone().add(2, 'day').startOf('day');
                        }
                        this.filterState = this.filterStateInit;
                    }
                }
            }
        },
        props: {
            state: Object,
            dayModeShiftsSelected: [Object, Array],
            header: String,
            date: Object,
        },
        computed:{
            sortState(){
                let sortState = {};
                sortState[this.$t('global.general.pos')] = 'descending';
                sortState[this.$t('global.general.from')] = null;
                sortState[this.$t('global.general.to')] = null;
                sortState[this.$t('roster.comp.length')] = null;
                return sortState;
            },
            pages(){
                let view = this;
                let pages = [];
                let filtered = this.shifts.slice();
                for(let x in this.filterState){
                    filtered = filtered.filter(i => view.filterOptions[x].filterCheck(i));
                }
                for(let x = 0; x < Math.ceil(filtered.length / this.shiftsPerPage); x++){
                    pages.push(x);
                }
                return pages;
            },
            shiftMomentMap(){
                let shifts = {};
                for(let x in this.shifts){
                    let shift = this.shifts[x];
                    let shiftTemp = {};
                    for(let key in shift) {
                        shiftTemp[key] = shift[key];
                    }
                    if(!shiftTemp.fromDate && shiftTemp.from) shiftTemp.fromDate = this.$helpers.getMomentFromStringTZ(shiftTemp.from);
                    if(!shiftTemp.toDate && shiftTemp.to) shiftTemp.toDate = this.$helpers.getMomentFromStringTZ(shiftTemp.to);
                    shifts[shiftTemp.id] = shiftTemp;
                }
                return shifts;
            },
            shiftsFiltered(){
                let view = this;
                if(this.shifts.length === 0) return [];
                let filtered = this.shifts.slice();
                if(this.filterToggle) {
                    for (let x in this.filterState) {
                        filtered = filtered.filter(i => view.filterOptions[x].filterCheck(i));
                    }
                }
                let paged = filtered.slice(this.tabSelected * this.shiftsPerPage, (this.tabSelected + 1) * this.shiftsPerPage);
                return paged;
            },
            filterOptions() {
                let view = this;
                let state = {};
                state.spotId = {label: this.$tc('shift.main.position'), type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.spotMap).map(s => {
                            return {
                                label: s.name,
                                value: s.id,
                                iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                selected: view.filterState.spotId.find(v => v === s.id)
                            }
                        }),
                    },
                    filterCheck: (data) => {
                        return  view.filterState.spotId.length === 0 || view.filterState.spotId.find(v => v === data.spotId)
                    }
                };
                state.from  = {label: this.$t('global.general.from'),type: 'datetimeframe', value: view.filterState.from,
                    filterCheck: (data) => {
                        return view.$helpers.getMomentFromStringTZ(data.from) > view.filterState.from;
                    }
                };
                state.to  = {label: this.$t('global.general.to'),type: 'datetimeframe', value: view.filterState.to,
                    filterCheck: (data) => {
                        return view.$helpers.getMomentFromStringTZ(data.to) < view.filterState.to;
                    }
                };
                for(let [k,v] of Object.entries(state)){
                    if(!v.label) v.label = view.$helpers.ConvertKeyToName(k);
                }
                return state;
            },
            sortOptions() {
                let view = this;
                let state = {};
                state.spotId = {label: this.$tc('shift.main.position'), type: 'dropdownsearch',
                    dropdownSearchState: {
                        selectMultiple: true, styleLight: true,
                        items: Object.values(this.spotMap).map(s => {
                            return {
                                label: s.name,
                                value: s.id,
                                iconLeft: {icon: 'fa-circle', type: 'small',styleButton: {'margin-left': '-9px', 'margin-top': '1px'}, styleIcon: {color: s.color + ' !important', 'text-shadow': '0 0 1px black, 0 0 1px black, 0 0 1px black;'}},
                                selected: view.filterState.spotId.find(v => v === s.id)
                            }
                        }),
                    },
                    filterCheck: (data) => {
                        return  view.filterState.spotId.length === 0 || view.filterState.spotId.find(v => v === data.spotId)
                    }
                };
                state.from  = {label: this.$t('global.general.from'),type: 'datetimeframe', value: view.filterState.from,
                    filterCheck: (data) => {
                        return view.$helpers.getMomentFromStringTZ(data.from) > view.filterState.from;
                    }
                };
                state.to  = {label: this.$t('global.general.to'),type: 'datetimeframe', value: view.filterState.to,
                    filterCheck: (data) => {
                        return view.$helpers.getMomentFromStringTZ(data.to) < view.filterState.to;
                    }
                };
                for(let [k,v] of Object.entries(state)){
                    if(!v.label) v.label = view.$helpers.ConvertKeyToName(k);
                }
                return state;
            }
        },
        methods: {
            openShiftContextMenu($event, shift){
                if(!shift || shift.published || shift.locked){
                    return;
                }

                this.$parent.$refs.shiftcontextmenu.showMenu($event, {shift: shift});
            },

            SortShifts(key){
                let view = this;
                let previousSort = this.sortState[key];
                for(let x in this.sortState){
                    this.sortState[x] = null;
                }
                this.sortState[key] = previousSort === 'descending' ? 'ascending' : 'descending';
                if(key === this.$t('global.general.pos')){
                    if(this.sortState[key] === 'descending'){
                        this.shifts.sort((a,b) => {
                            return view.shiftMomentMap[a.id].from > view.shiftMomentMap[b.id].from ? 1 : -1;
                        })
                    }
                    if(this.sortState[key] === 'ascending'){
                        this.shifts.sort((a,b) => {
                            return view.shiftMomentMap[a.id].from < view.shiftMomentMap[b.id].from ? 1 : -1;
                        })
                    }
                }
                if(key === this.$t('global.general.from')){
                    if(this.sortState[key] === 'descending'){
                        this.shifts.sort((a,b) => {
                            return view.shiftMomentMap[a.id].fromDate > view.shiftMomentMap[b.id].fromDate ? 1 : -1;
                        })
                    }
                    if(this.sortState[key] === 'ascending'){
                        this.shifts.sort((a,b) => {
                            return view.shiftMomentMap[a.id].fromDate > view.shiftMomentMap[b.id].fromDate ? 1 : -1;
                        })
                    }
                }
                if(key === this.$t('global.general.to')){
                    if(this.sortState[key] === 'descending'){
                        this.shifts.sort((a,b) => {
                            return view.shiftMomentMap[a.id].toDate > view.shiftMomentMap[b.id].toDate ? 1 : -1;
                        })
                    }
                    if(this.sortState[key] === 'ascending'){
                        this.shifts.sort((a,b) => {
                            return view.shiftMomentMap[a.id].toDate > view.shiftMomentMap[b.id].toDate ? 1 : -1;
                        })
                    }
                }
                if(key === this.$t('roster.comp.length')){
                    if(this.sortState[key] === 'descending'){
                        this.shifts.sort((a,b) => {
                            return (view.shiftMomentMap[a.id].toDate._d.getTime() - view.shiftMomentMap[a.id].fromDate._d.getTime()) > (view.shiftMomentMap[b.id].toDate._d.getTime() - view.shiftMomentMap[b.id].fromDate._d.getTime()) ? 1 : -1;
                        })
                    }
                    if(this.sortState[key] === 'ascending'){
                        this.shifts.sort((a,b) => {
                            return (view.shiftMomentMap[a.id].toDate._d.getTime() - view.shiftMomentMap[a.id].fromDate._d.getTime()) < (view.shiftMomentMap[b.id].toDate._d.getTime() - view.shiftMomentMap[b.id].fromDate._d.getTime()) ? 1 : -1;
                        })
                    }
                }
                this.$forceUpdate();
                //return shifts;
            },
            DragStart($event, shift){
                this.$emit('DragStart', $event, shift);
            },
            ShiftSelect(shift){
                this.$emit('ShiftSelect', shift);
            },
            ToggleFilter(){
                this.filterToggle = !this.filterToggle;
            },
            OpenFilterPopup($event){
                let view = this;
                view.$helpers.OpenPopup({
                    elRelative: $event.currentTarget,
                    type: 'datafill',
                    componentState: {
                        entries: this.filterOptions,
                        selectCallback: (filterNew) => {
                            view.filterState = filterNew;
                        },
                        deleteCallback: () => {
                            view.filterState = view.filterStateInit;
                        },
                    },
                    expanded: true,
                    header: 'Filters',
                    pointerDirection: 1,
                });
            },
        },
    }
</script>

<style scoped>
    .shift-container{
        height: 50%;
        height: calc(50% - 47px);
        clear: both;
        margin-top: 10px;
        position: relative;
    }

    .header {
        width: 100%;
    }

    .page-container{
        height: 30px;
        position: relative;
        margin: 5px 0;
        text-align: left;
        padding: 0 10px;
    }

    .tab{
    }

    .tab:hover{
        background: var(--contrast-1);
        filter: brightness(120%);
    }

    .tab:not(:hover){
        background: var(--contrast-8);
    }

    .tab-header.hover-gray .tab:hover{
        background: var(--contrast-3);
        filter: initial;
    }

    .tab.selected{
        background: var(--contrast-1);
    }

    .tab{
        margin: 0 2.5px;
        cursor: pointer;
        align-content: center;
        height: 100%;
        padding: 0 10px;
    }
    .scroll-list{
        height: calc( 100% - 75px);
        overflow-y: auto;
        padding: 0 10px;
        padding: 0 40px;
    }.shift{
         position: relative;
         /* width: 100%; */
         float: left;
         margin-top: 5px;
         margin-right: 5px;
     }

    .filter{
        position: absolute;
        height: 30px;
        width: 30px;
        right: 40px;
    }

    .filter.toggle{
        position: absolute;
        height: 30px;
        width: 30px;
        right: 10px;
    }

    .sort{
        position: absolute;
        height: 30px;
        width: 30px;
        right: 70px;
    }
</style>
